var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    {
      attrs: { title: _vm.title, button_add: true },
      on: { click_add: _vm.click_add },
    },
    [
      _c("r-reminder-table", {
        ref: "table",
        attrs: { items: _vm.value.items, toolbar: false, title: _vm.title },
        on: {
          "update:items": function ($event) {
            return _vm.$set(_vm.value, "items", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }